import { jsxs as d, jsx as k } from "react/jsx-runtime";
import { forwardRef as u, useCallback as x } from "react";
import l from "./styles.module.less.js";
const i = u((e, s) => {
  var r;
  const { checked: n = !1, value: a, label: h, disabled: c, onChange: o, error: b } = e, m = x((t) => {
    c || o(t.target.value, t.target.checked);
  }, [c, o]);
  return /* @__PURE__ */ d("label", { className: `${l.checkboxInputLabel} ${e.labelClassName ?? ""} ${b ? l.error : ""}`, htmlFor: `checkbox-${a}`, children: [
    /* @__PURE__ */ k(
      "input",
      {
        id: `checkbox-${a}`,
        ref: s,
        ...e.props,
        className: `${l.checkboxInput} ${((r = e.props) == null ? void 0 : r.className) || ""}`,
        type: "checkbox",
        value: a,
        checked: n,
        onChange: m,
        disabled: c
      }
    ),
    h
  ] });
});
i.displayName = "CheckboxInput";
export {
  i as CheckboxInput,
  i as default
};
